import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';

const Navbar = () => {
  const navigate = useNavigate();
  const { logOut, userData } = useAuth();

  const handleLogout = () => {
    logOut();
    navigate('/');
  };

  return (
    <AppBar position="static" sx={{ mb: 2 }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Typography variant="h6" component="div">
          Alta de Unidades
        </Typography>
        <Box>
          {userData && (
            <Typography variant="body2" component="span" sx={{ mr: 2 }}>
              {userData.nombre || userData.username || 'Usuario'}
            </Typography>
          )}
          <Button color="inherit" onClick={() => navigate('/')}>
            Inicio
          </Button>
          <Button color="inherit" onClick={() => navigate('/dashboard')}>
            Dashboard
          </Button>
          <Button color="inherit" onClick={handleLogout}>
            Cerrar Sesión
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;